import React from 'react';

export default function IsLoading(text) {
  return (
    <div style={styles.page}>
      <div style={styles.card} aria-live="polite" aria-busy="true">
        <div style={styles.mark}>
          <span style={{ ...styles.dot, ...styles.dotOne }} />
          <span style={{ ...styles.dot, ...styles.dotTwo }} />
          <span style={{ ...styles.dot, ...styles.dotThree }} />
        </div>
        <div style={styles.copy}>
          <span style={styles.eyebrow}>LearningHell</span>
          <h1 style={styles.title}>{text.text || 'Yukleniyor'}</h1>
        </div>
      </div>
      <style>{`
        @keyframes editorialLoaderRise {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.55; }
          40% { transform: translateY(-12px); opacity: 1; }
        }
        @keyframes editorialLoaderCard {
          0%, 100% { box-shadow: 0 18px 46px rgba(58, 45, 34, 0.10); }
          50% { box-shadow: 0 24px 58px rgba(58, 45, 34, 0.14); }
        }
      `}</style>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
    background: 'linear-gradient(90deg, rgba(47, 79, 64, 0.05) 1px, transparent 1px), linear-gradient(0deg, rgba(47, 79, 64, 0.045) 1px, transparent 1px), linear-gradient(135deg, #f7f0e4 0%, #efe2cf 100%)',
    backgroundSize: '34px 34px, 34px 34px, auto',
  },
  card: {
    width: 'min(360px, 92vw)',
    minHeight: '210px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '22px',
    background: 'rgba(255, 251, 243, 0.94)',
    border: '1px solid rgba(110, 90, 66, 0.2)',
    borderRadius: '8px',
    boxShadow: '0 18px 46px rgba(58, 45, 34, 0.10)',
    animation: 'editorialLoaderCard 2.6s ease-in-out infinite',
  },
  mark: {
    width: '96px',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    borderBottom: '1px solid rgba(110, 90, 66, 0.18)',
  },
  dot: {
    width: '14px',
    height: '14px',
    display: 'block',
    borderRadius: '4px',
    background: '#2f4f40',
    animation: 'editorialLoaderRise 1.15s ease-in-out infinite',
  },
  dotOne: {
    background: '#2f4f40',
    animationDelay: '0s',
  },
  dotTwo: {
    background: '#8d4e2f',
    animationDelay: '0.14s',
  },
  dotThree: {
    background: '#c2734b',
    animationDelay: '0.28s',
  },
  copy: {
    textAlign: 'center',
  },
  eyebrow: {
    display: 'block',
    marginBottom: '6px',
    color: '#6f665a',
    fontSize: '0.78rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0,
  },
  title: {
    margin: 0,
    color: '#2d241b',
    fontFamily: 'Georgia, Times New Roman, serif',
    fontSize: 'clamp(1.7rem, 6vw, 2.35rem)',
    fontWeight: 500,
    lineHeight: 1,
  },
};
